import React, { useContext } from "react";
import PropTypes from "prop-types";
import NavbarDropdown from "./NavbarDropdown";
import NavbarDropdownComponents from "./NavbarDropdownComponents";
import {
  dashboardRoutes as dashboardRoutesA,
  partnersRoutes as partnersRoutesA,
  analyticsRoutes as analyticsRoutesA,
  documentationRoutes as documentationRoutesA,
  webhookRoutes as webhookRoutesA,
  apiExplorerRoutes as apiExplorerRoutesA,
  settingsRoutes as settingsRoutesA,
  billingRoutes as billingRoutesA,
  errorCodesRoutes as errorCodesRoutesA
} from "../../adminRoutes";
import {
  dashboardRoutes as dashboardRoutesU,
  applicationsRoutes as applicationsRoutesU,
  // analyticsRoutes as analyticsRoutesU,
  documentationRoutes as documentationRoutesU,
  webhookRoutes as webhookRoutesU,
  notifyRoutes,
  apiExplorerRoutes as apiExplorerRoutesU,
  settingsRoutes as settingsRoutesU,
  billingRoutes as billingRoutesU,
  errorCodesRoutes as errorCodesRoutesU
} from "../../userRoutes";
import { NavItem } from "reactstrap";
import { NavLink } from "react-router-dom";
import { breakpoints, getPageName } from "../../helpers/utils";
import { navbarBreakPoint, topNavbarBreakpoint } from "../../config";
import AppContext from "../../context/Context";

const NavbarTopDropDownMenus = ({ setNavbarCollapsed, setShowBurgerMenu }) => {
  const { isCombo, isTopNav, loginUserDetails } = useContext(AppContext);
  const handleSetNavbarCollapsed = () => {
    const windowWidth = window.innerWidth;
    isTopNav && !isCombo && windowWidth < breakpoints[topNavbarBreakpoint] && setNavbarCollapsed(false);
    isCombo && windowWidth < breakpoints[navbarBreakPoint] && setShowBurgerMenu(false);
  };

  const isLanding = getPageName("landing");
  return (
    <>
      {loginUserDetails?.is_partner === "0" ? (
        <>
          <NavItem onClick={handleSetNavbarCollapsed}>
            <NavLink className="nav-link" to={dashboardRoutesA.to}>
              {dashboardRoutesA.name}
            </NavLink>
          </NavItem>
          <NavbarDropdown
            title={partnersRoutesA.name}
            items={partnersRoutesA.children}
            handleSetNavbarCollapsed={handleSetNavbarCollapsed}
          />
          <NavbarDropdown
            title={analyticsRoutesA.name}
            items={analyticsRoutesA.children}
            handleSetNavbarCollapsed={handleSetNavbarCollapsed}
          />
          <NavbarDropdown
            title={documentationRoutesA.name}
            items={documentationRoutesA.children}
            handleSetNavbarCollapsed={handleSetNavbarCollapsed}
          />
          <NavbarDropdown
            title={webhookRoutesA.name}
            items={webhookRoutesA.children}
            handleSetNavbarCollapsed={handleSetNavbarCollapsed}
          />
          <NavItem onClick={handleSetNavbarCollapsed}>
            <NavLink className="nav-link" to={apiExplorerRoutesA.to}>
              {apiExplorerRoutesA.name}
            </NavLink>
          </NavItem>

          <NavbarDropdown
            title={errorCodesRoutesA.name}
            items={errorCodesRoutesA.children}
            handleSetNavbarCollapsed={handleSetNavbarCollapsed}
            />

          <NavbarDropdown
            title={settingsRoutesA.name}
            items={settingsRoutesA.children}
            handleSetNavbarCollapsed={handleSetNavbarCollapsed}
          />
          <NavbarDropdown
            title={billingRoutesA.name}
            items={billingRoutesA.children}
            handleSetNavbarCollapsed={handleSetNavbarCollapsed}
          />
        </>
      ) : (
        <>
          <NavItem onClick={handleSetNavbarCollapsed}>
            <NavLink className="nav-link" to={dashboardRoutesU.to}>
              {dashboardRoutesU.name}
            </NavLink>
          </NavItem>
          <NavItem onClick={handleSetNavbarCollapsed}>
            <NavLink className="nav-link" to={applicationsRoutesU.to}>
              {applicationsRoutesU.name}
            </NavLink>
          </NavItem>
          {/* <NavbarDropdown
            title={analyticsRoutesU.name}
            items={analyticsRoutesU.children}
            handleSetNavbarCollapsed={handleSetNavbarCollapsed}
          /> */}
          <NavbarDropdown
            title={documentationRoutesA.name}
            items={documentationRoutesA.children}
            handleSetNavbarCollapsed={handleSetNavbarCollapsed}
          />
          <NavItem onClick={handleSetNavbarCollapsed}>
            <NavLink className="nav-link" to={webhookRoutesU.to}>
              {webhookRoutesU.name}
            </NavLink>
          </NavItem>
          <NavItem onClick={handleSetNavbarCollapsed}>
            <NavLink className="nav-link" to={notifyRoutes.to}>
              {notifyRoutes.name}
            </NavLink>
          </NavItem>
          <NavItem onClick={handleSetNavbarCollapsed}>
            <NavLink className="nav-link" to={apiExplorerRoutesU.to}>
              {apiExplorerRoutesU.name}
            </NavLink>
          </NavItem>
          <NavItem onClick={handleSetNavbarCollapsed}>
            <NavLink className="nav-link" to={errorCodesRoutesU.to}>
              {errorCodesRoutesU.name}
            </NavLink>
          </NavItem>
          <NavbarDropdown
            title={settingsRoutesU.name}
            items={settingsRoutesU.children}
            handleSetNavbarCollapsed={handleSetNavbarCollapsed}
          />
          <NavItem onClick={handleSetNavbarCollapsed}>
            <NavLink className="nav-link" to={billingRoutesU.to}>
              {billingRoutesU.name}
            </NavLink>
          </NavItem>
        </>
      )}
    </>
  );
};

NavbarTopDropDownMenus.propTypes = {
  setNavbarCollapsed: PropTypes.func.isRequired,
};

export default NavbarTopDropDownMenus;
